import getEnv from './lib/getEnv';

//  http://one-test.wywk.cn
let Settings = {};
const env = getEnv();

const protocol = window.location.protocol || 'http:';

// console.error('protocol--->>>', window.location);

const SSO_URL =
  'https://wysso.wywk.cn/oauth2.0/authorize?response_type=code&client_id=MTFkMmI0ZTAwYjE1OWNmYjdkY2VhYWZiCg&redirect_uri=';

switch (env) {
  case 'dev':
    Settings = {
      API: '//taiyi-test.wywk.cn',
      SSO_URL,
      REDIRECT_URI: window.location.origin,
    };
    break;
  case 'canary':
    Settings = {
      API: '//taiyi-test.wywk.cn',
      SSO_URL,
      REDIRECT_URI: protocol + '//one-test.wywk.cn',
    };
    break;
  case 'uat':
    Settings = {
      API: '//taiyi-web-uat.wywk.cn',
      SSO_URL,
      REDIRECT_URI: protocol + '//one-uat.wywk.cn',
    };
    break;
  case 'prod':
    Settings = {
      API: '//taiyi-web.wywk.cn',
      SSO_URL,
      REDIRECT_URI: protocol + '//one.wywk.cn',
    };
    break;
  default:
    Settings = {
      API: '//taiyi-test.wywk.cn',
      SSO_URL,
      REDIRECT_URI: protocol + '//one-test.wywk.cn',
    };
    break;
}

export default Settings;
